module.exports = __webpack_public_path__ + "static/media/ChapmanLabsVerticalDark-FixedColors-Official-375x250.4658a77d.png";